<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card flex-1">
    <div class="qb-detail-card w-full h-fit">
      <div class="flex flex-col gap-3">
        <!-- Row 1: Name (9) + Status (3) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Name" class="col-span-9">
            <input #firstInput [(ngModel)]="feature.name" [bzModel]="feature" name="name" pInputText title="Name" />
          </qb-field>
          <qb-field label="Status" class="col-span-3">
            <p-dropdown
              [(ngModel)]="feature.activeStatusId"
              [bzModel]="feature"
              name="activeStatusId"
              [options]="activeStatuses"
              optionValue="id"
              optionLabel="name"
            />
          </qb-field>
        </div>
        <!-- Row 2: Display Name (9) + Feature Type (3) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Display Name" class="col-span-9">
            <input [(ngModel)]="feature.docName" [bzModel]="feature" name="docName" pInputText title="Display Name" />
          </qb-field>
          <!-- What the feature MEANS, as against what it is called. The feed reads this to decide
               which features a product type must carry, so it is required and, once a feed
               manufacturer depends on it, fixed. -->
          <qb-field label="Feature Type" class="col-span-3">
            <p-dropdown
              [(ngModel)]="feature.featureKindId"
              [bzModel]="feature"
              name="featureKindId"
              [options]="featureKinds"
              optionValue="id"
              optionLabel="name"
              placeholder="Select"
              [disabled]="isFeatureKindLocked"
            />
          </qb-field>
        </div>
        <div *ngIf="isFeatureKindLocked" class="grid grid-cols-12">
          <span class="col-span-12 text-xs italic" style="color: var(--p-text-muted-color, #6b7280)">
            {{ featureKindLockReason }}
          </span>
        </div>
        <!-- Row 3: Mismatch Addon Name And Location (9) + Checkbox (3) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Mismatch Addon Name And Location" class="col-span-9">
            <input [(ngModel)]="feature.mismatchAddonNameAndLocation" [bzModel]="feature" name="mismatchAddonNameAndLocation" pInputText title="Mismatch Addon Name And Location" />
          </qb-field>
          <div class="col-span-3 flex items-center gap-2 mt-6">
            <p-checkbox
              [disabled]="feature.mismatchAddonNameAndLocation == null || feature.mismatchAddonNameAndLocation.trim().length == 0"
              [(ngModel)]="feature.mismatchAddonIsCrossAccount"
              [bzModel]="feature"
              name="mismatchAddonIsCrossAccount"
              inputId="mismatchAddonIsCrossAccount"
              [binary]="true"
            />
            <label for="mismatchAddonIsCrossAccount">Cross Account?</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button [disabled]="!this.uow.hasChanges()" (click)="ok()" pButton type="button" label="Ok" title="Ok" icon="pi pi-check" class="p-button-raised"></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
